<template>
  <div class="tag-bar">
    <Tag
      v-for="(tag, index) in tags"
      :key="index"
      class="post-tag"
      @click.native="handleTagSelect(tag)"
    >
      {{ tag }}
    </Tag>
  </div>
</template>

<script>
export default {
  props: {
    tags: Array
  },

  methods: {
    handleTagSelect (tag) {
      this.$emit('forumTagSelection', tag)
    }
  }
}
</script>

<style scoped>
.tag-bar {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.post-tag {
  background-color: transparent;
  cursor: pointer;
}

.post-tag >>> .ivu-tag-text {
  color: var(--color-green-thick);
}
</style>
